import { render, staticRenderFns } from "./PreviewTalentMatrix.vue?vue&type=template&id=28f1c388&scoped=true"
import script from "./PreviewTalentMatrix.vue?vue&type=script&lang=js"
export * from "./PreviewTalentMatrix.vue?vue&type=script&lang=js"
import style0 from "./PreviewTalentMatrix.vue?vue&type=style&index=0&id=28f1c388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1c388",
  null
  
)

export default component.exports